import { createSlice } from "@reduxjs/toolkit";
import customFailAlert from "../../Alerts/customFailAlert";

import customSuccessAlert from "../../Alerts/customSuccessAlert";
import {
  GetStrategyTable,
  Strategyperformancegraph,
  GetAllUserStrategies,
  PatchUserStrategies,
} from "../Actions/strategyService";

const initialState = {
  error: "",
  code: "",
  status: "",
  loading: false,
  strategyData: [],
  custodianData: [],
  allUserStrategies: [],
  UpdateUserStrategies:[],
};
const strategyReducer = createSlice({
  name: "strategy",
  initialState,
  reducers: {},
  extraReducers: {
    [GetStrategyTable.pending]: (state, action) => {
      state.loading = true;
    },
    [GetStrategyTable.fulfilled]: (
      state,
      { payload: { status, data, message, code } }
    ) => {
      state.loading = false;
      if (
        (code === 200 || status?.toUpperCase() === "SUCCESS") &&
        data?.strategyResponseDtoList
      ) {
        state.strategyData = data?.strategyResponseDtoList;
        state.message = message;
        state.status = status;
        state.code = code;
      } else {
        state.strategyData = [];
        state.error = message;
        state.status = status;
        state.code = code;
      }
    },
    [GetStrategyTable.rejected]: (state, action) => {
      state.loading = false;
    },


    [Strategyperformancegraph.fulfilled]: (
      state,
      { payload: { code, message, status, data } }
    ) => {
      state.loading = false;
      if (code !== 200) {
        state.status = status;
        state.error = message;
        state.code = code;
      } else {
        state.status = status;
        state.message = message;
        state.code = code;
        state.strategygraph = data;
      }
    },
    [Strategyperformancegraph.pending]: (state) => {
      state.loading = true;
    },
    [Strategyperformancegraph.rejected]: (state) => {
      state.loading = false;
    },

    [GetAllUserStrategies.pending]: (state, action) => {
      state.loading = true;
    },
    [GetAllUserStrategies.fulfilled]: (state,{ payload: { status, data, message, code } }) => {
      state.loading = false;
      if (
        (code === 200 || status?.toUpperCase() === "SUCCESS") ||
        data
      ) {
        state.allUserStrategies = data;
        state.message = message;
        state.status = status;
        state.code = code;
      } else {
        state.allUserStrategies = [];
        state.error = message;
        state.status = status;
        state.code = code;
      }
    },
    [GetAllUserStrategies.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    //Patch User Strategies
    [PatchUserStrategies.pending]: (state, action) => {
      state.loading = true;
    },

    [PatchUserStrategies.fulfilled]: (state,{ payload: { statusCode, message } }) => {
      state.loading = false;
      if (
        (statusCode === 200)
      ) {
        state.message = message;
        state.status = statusCode;
        customSuccessAlert(message || "Operation completed successfully!");
      } else {
        state.error = message;
        state.status = statusCode;
        customFailAlert(message || "Operation failed.");
      }
    },


    [PatchUserStrategies.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

  },
});

export default strategyReducer.reducer;
